import React, { FC } from 'react';
import classnames from 'classnames';

import CommonUtils from 'application/utils/CommonUtils';

import { CURRENCIES_SIGNS } from 'application/pages/constants';

import { Currencies, PricePlanRowPureType } from 'domain/api/graphql/generated';

import IconInfo from '@zvuk-b2b/react-uikit/ui/icons/Info';

import { TEXTS } from './texts';
import useRatesTableViewModel from './useRatesTableViewModel';
import PrimeDiscount from './PrimeDiscount';
import { getSubscriptionPeriod, getText } from './utils';

import styles from './index.module.scss';

interface RatesTableRows {
  className?: string;
  pricePlanTitle: string;
  pricePlanCurrency: Currencies;
  periodPayFrequencyMonth: number;
  rows: PricePlanRowPureType[];
  withInfoIcon?: boolean;
  elementIdPrefix?: string;
}

const RatesTable: FC<RatesTableRows> = ({
  periodPayFrequencyMonth,
  pricePlanTitle,
  pricePlanCurrency,
  rows,
  className,
  withInfoIcon = false,
  elementIdPrefix = 'current_price_plan',
}) => {
  const { isChangePricePlanAvailable, isPrimeDiscountAvailable, primeDiscountValue } = useRatesTableViewModel();

  return (
    <div className={styles.container}>
      {withInfoIcon && <IconInfo className={styles.infoIcon} />}
      <table
        className={classnames(styles.ratesTable, className)}
        data-top-space={!isChangePricePlanAvailable}>
        <thead className={styles.title}>
          <tr>
            <td className={styles.description}>{TEXTS.RATES_TABLE_PRICES_TITLE(pricePlanTitle)}</td>
          </tr>
        </thead>
        <tbody>
          {isPrimeDiscountAvailable && rows.length > 0 && (
            <PrimeDiscount
              primeDiscountValue={
                primeDiscountValue
              }>{`${CommonUtils.numberWithSeparation(rows[0].amount)} ₽`}</PrimeDiscount>
          )}

          {rows.map((row, index) => (
            <tr
              key={row.id}
              id={`${elementIdPrefix}_${row.id}`}>
              <td className={styles.description}>
                {getText({ row, withPrimeDiscount: isPrimeDiscountAvailable && row.stepRangeLower === 1 })}
              </td>
              <td
                className={styles.ratesTablePrice}
                id={`${elementIdPrefix}_tariff_data_${index + 1}`}>
                {CommonUtils.numberWithSeparation(row.amount)}
                &nbsp;
                {CURRENCIES_SIGNS[pricePlanCurrency]}
                &nbsp;
                <span>{getSubscriptionPeriod(periodPayFrequencyMonth)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(RatesTable);
